export default __webpack_public_path__ + "static/media/04__o_0.92112610.jpg";